/**
 * انتخاب‌های لیستِ بیمه پیش از ساختنِ فایل (v2.160.0 ⇒ مشترک از v2.164.0).
 *
 * کاربر (۱۴۰۵/۰۸/۰۷): «موقعِ گرفتنِ لیستِ بیمه بپرسد کدام حساب‌ها (سامان/اصلی/بانکِ دیگر/همه)، پیش‌فرض هم داشته باشد؛ یک لیست هم
 * باشد که کسانی که پرداختی‌شان را گرفته‌اند در آن نیایند». هم صفحهٔ محاسبهٔ حقوق و هم صفحهٔ بیمه از همین استفاده می‌کنند.
 * `onOk({accounts, unpaid_only})`.
 */
import React, { useEffect, useState } from "react";
import { Checkbox, Divider, Input, Modal, Radio } from "antd";

const KEY = "gx.insurance.accounts";
const read = () => { try { return localStorage.getItem(KEY) || "bank:سامان"; } catch { return "bank:سامان"; } };

export default function InsuranceListModal({ open, title, onCancel, onOk, defaultUnpaid = false }) {
  const [acc, setAcc] = useState(read);
  const [other, setOther] = useState("");
  const [remember, setRemember] = useState(false);
  const [unpaid, setUnpaid] = useState(defaultUnpaid);
  useEffect(() => { if (open) { setAcc(read()); setRemember(false); setUnpaid(defaultUnpaid); } }, [open, defaultUnpaid]);

  const isOther = acc === "other" || (acc.startsWith("bank:") && acc !== "bank:سامان");
  const ok = () => {
    const a = acc === "other" ? (other.trim() ? `bank:${other.trim()}` : "primary") : acc;
    if (remember) { try { localStorage.setItem(KEY, a); } catch { /* بی‌حافظه */ } }
    onOk({ accounts: a, unpaid_only: unpaid });
  };
  return (
    <Modal open={open} title={title || "لیست بیمه — کدام حساب در لیست بیاید؟"} okText="ساختِ لیست" cancelText="انصراف"
      onCancel={onCancel} onOk={ok}>
      <Radio.Group value={isOther ? "other" : acc} onChange={(e) => setAcc(e.target.value)}
        style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        <Radio value="bank:سامان">حسابِ بانک سامان (هر کس سامان ندارد ⇒ حسابِ اصلی، با یادداشت)</Radio>
        <Radio value="primary">حسابِ اصلیِ هر نفر (همان حسابِ پرداخت‌ها)</Radio>
        <Radio value="other">بانکِ دیگر:
          <Input size="small" style={{ width: 140, marginInlineStart: 8 }} placeholder="مثلاً ملی"
            value={other || (isOther && acc !== "other" ? acc.slice(5) : "")}
            onChange={(e) => { setOther(e.target.value); setAcc("other"); }} /></Radio>
        <Radio value="all">همهٔ حساب‌ها (اصلی + ستونِ «سایرِ حساب‌ها»)</Radio>
      </Radio.Group>
      <Checkbox style={{ marginTop: 10 }} checked={remember} onChange={(e) => setRemember(e.target.checked)}>
        همین حساب، پیش‌فرضِ من باشد</Checkbox>
      <Divider style={{ margin: "12px 0" }} />
      <Checkbox checked={unpaid} onChange={(e) => setUnpaid(e.target.checked)}>
        فقط کسانی که هنوز پرداختیِ بیمه نگرفته‌اند (نفراتِ پرداخت‌شده در مرحلهٔ ۲ نیایند)</Checkbox>
    </Modal>
  );
}
